import { CheckCircleIcon, QuestionMarkCircleIcon, XCircleIcon, } from '@heroicons/react/solid';
import { isDefined, dedupeArray } from '@showroomjs/core';
import { Collapsible, styled, Checkbox } from '@showroomjs/ui';
import * as React from 'react';
export const A11yResultItem = (props) => {
    const Icon = iconByType[props.type];
    const [showDetails, setShowDetails] = React.useState(false);
    const result = props.result;
    const allSelectors = React.useMemo(() => dedupeArray(result.nodes.map((node) => node.target[0]).filter(isDefined)), [result]);
    const checkStatus = React.useMemo(() => allSelectors.every((s) => props.highlightedItems.includes(s))
        ? true
        : allSelectors.some((s) => props.highlightedItems.includes(s))
            ? 'indeterminate'
            : false, [allSelectors, props.highlightedItems]);
    return (React.createElement(Root, null,
        React.createElement(Collapsible.Root, { open: showDetails, onOpenChange: setShowDetails },
            React.createElement(ResultTitle, null,
                React.createElement(Collapsible.Button, { css: {
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'left',
                        gap: '$1',
                        fontSize: '$sm',
                        lineHeight: '$sm',
                        color: '$gray-800',
                        flex: 1,
                    } },
                    React.createElement(Collapsible.ToggleIcon, { direction: showDetails ? 'down' : 'right', width: 16, height: 16 }),
                    result.help,
                    React.createElement(Icon, { width: 16, height: 16 })),
                React.createElement(Checkbox, { checked: checkStatus, onCheckedChange: (allChecked) => {
                        if (allChecked) {
                            props.setHighlightedItems((prev) => dedupeArray(prev.concat(allSelectors)));
                        }
                        else {
                            props.setHighlightedItems((prev) => prev.filter((item) => allSelectors.indexOf(item) === -1));
                        }
                    } })),
            React.createElement(Collapsible.Content, { animate: true },
                React.createElement(ItemDetails, null,
                    React.createElement(Text, null, result.description),
                    React.createElement(Text, null,
                        React.createElement(ItemLink, { href: result.helpUrl, target: "_blank", rel: "noopener noreferrer" }, "Learn more")),
                    React.createElement(ElementList, null, result.nodes.map((n, i) => (React.createElement("li", { key: i },
                        React.createElement(Element, { element: n, highlighted: n.target[0]
                                ? props.highlightedItems.includes(n.target[0])
                                : false, toggleHighlight: () => {
                                n.target[0] && props.toggleItem(n.target[0]);
                            } }))))))))));
};
const Text = styled('p', {
    margin: 0,
    padding: 0,
});
const ResultTitle = styled('div', {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '$4',
});
export const Root = styled('li', {
    py: '$1',
    borderBottom: '1px solid $gray-200',
    '&:last-child': {
        borderBottom: 0,
    },
});
const ItemDetails = styled('div', {
    px: '$2',
    py: '$2',
    fontSize: '$sm',
    lineHeight: '$sm',
    color: '$gray-800',
});
const ItemLink = styled('a', {
    color: '$blue-800',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
});
const ElementList = styled('ol', {
    listStyleType: 'decimal',
    paddingLeft: '$6',
    marginTop: '$3',
    '& li': {
        marginBottom: '$2',
    },
    '& li:last-child': {
        marginBottom: 0,
    },
});
const SuccessIcon = styled(CheckCircleIcon, {
    color: '$green-500',
    width: 16,
    height: 16,
    flexShrink: 0,
});
const DangerIcon = styled(XCircleIcon, {
    color: '$red-500',
    width: 16,
    height: 16,
    flexShrink: 0,
});
const UnknownIcon = styled(QuestionMarkCircleIcon, {
    color: '$yellow-500',
    width: 16,
    height: 16,
    flexShrink: 0,
});
const iconByType = {
    pass: SuccessIcon,
    violation: DangerIcon,
    incomplete: UnknownIcon,
};
const Element = (props) => {
    const { any, all, none } = props.element;
    const rules = [...any, ...all, ...none];
    return (React.createElement("div", null,
        React.createElement(ElementTitle, null,
            React.createElement(ElementText, null, props.element.target[0]),
            ' ',
            React.createElement(ElementCheckbox, null,
                React.createElement(Checkbox, { checked: props.highlighted, onCheckedChange: props.toggleHighlight }))),
        React.createElement(Rules, { rules: rules })));
};
const ElementTitle = styled('div', {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: '500',
    borderBottom: '1px solid $gray-300',
    paddingRight: '$2',
});
const ElementText = styled('p', {
    flex: 1,
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
});
const ElementCheckbox = styled('div', {
    flexShrink: 0,
});
const Rules = (props) => {
    return (React.createElement(RulesRoot, null, props.rules.map((r) => (React.createElement("li", { key: r.id },
        "[",
        r.impact,
        "] ",
        r.message)))));
};
const RulesRoot = styled('ul', {
    listStyle: 'none',
    margin: 0,
    padding: 0,
});
//# sourceMappingURL=a11y-result-item.js.map